// Tab buttons PDP
(function attachTabButtonsHandler() {
  function onTabButtonClick(event) {
    const clickedButton = event.target.closest('.tab-button');
    if (!clickedButton) return;

    const tabsContainer = clickedButton.closest('.tab-container');
    if (!tabsContainer) return;

    const tabKey = clickedButton.getAttribute('data-tab');
    if (!tabKey) return;

    // Update active state on buttons
    tabsContainer.querySelectorAll('.tab-button').forEach((btn) => btn.classList.remove('active'));
    clickedButton.classList.add('active');

    // Hide all lists, then show selected
    tabsContainer.querySelectorAll('.tab-list').forEach((list) => list.classList.add('hidden'));
    const targetList = tabsContainer.querySelector('#' + tabKey);
    if (targetList) targetList.classList.remove('hidden');
  }

  document.addEventListener('click', onTabButtonClick, false);
})();


// Influence.io launcher deep link: open via ?rewards=open

(function enableInfluenceLauncherDeepLink() {
  function shouldOpenFromQuery() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (!params.has('rewards')) return false;
      var value = params.get('rewards');
      if (value === null) return true; // bare ?rewards
      value = String(value).toLowerCase();
      return value === '' || value === '1' || value === 'true' || value === 'open';
    } catch (e) {
      return false;
    }
  }

  function waitForElement(selector, timeoutMs) {
    return new Promise(function(resolve, reject) {
      var element = document.querySelector(selector);
      if (element) return resolve(element);

      var resolved = false;
      var observer = new MutationObserver(function() {
        var el = document.querySelector(selector);
        if (el && !resolved) {
          resolved = true;
          observer.disconnect();
          resolve(el);
        }
      });
      observer.observe(document.documentElement || document.body, { childList: true, subtree: true });

      var timeoutId = setTimeout(function() {
        if (!resolved) {
          observer.disconnect();
          reject(new Error('Timeout waiting for ' + selector));
        }
      }, timeoutMs || 10000);
    });
  }

  function openLauncherIfNeeded(launcher) {
    try {
      if (!launcher) return;
      var isAlreadyOpen = launcher.classList.contains('isActive') || document.querySelector('.R-LauncherButton.isActive');
      if (isAlreadyOpen) return;
      launcher.click();
    } catch (e) {
      // no-op
    }
  }

  function init() {
    if (!shouldOpenFromQuery()) return;
    waitForElement('.R-LauncherButton', 15000)
      .then(function(launcher) { openLauncherIfNeeded(launcher); })
      .catch(function() { /* silently ignore if not present */ });
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }
})();

// Inject product-stamped-reviews snippet into Stamped.io main widget
(function injectStampedReviewsWidget() {
  var fullTemplate = document.getElementById('stamped-reviews-widget-full');
  var authenticityTemplate = document.getElementById('stamped-reviews-widget-authenticity');

  if (!fullTemplate && !authenticityTemplate) return;

  function cloneTemplateContent(template) {
    if (!template || !template.content || !template.content.firstElementChild) return null;
    return template.content.firstElementChild.cloneNode(true);
  }

  function injectIntoWidget(widget) {
    var didInject = false;

    if (fullTemplate && !widget.querySelector('[data-stamped-injected="full"]')) {
      var reviewOptions = widget.querySelector('.stamped-review-options');
      var fullContent = cloneTemplateContent(fullTemplate);

      if (reviewOptions && fullContent) {
        fullContent.dataset.stampedInjected = 'full';
        reviewOptions.parentNode.insertBefore(fullContent, reviewOptions);
        didInject = true;
      }
    }

    if (authenticityTemplate && !widget.querySelector('[data-stamped-injected="authenticity"]')) {
      var reviewsFilter = widget.querySelector('.stamped-reviews-filter');
      var authenticityContent = cloneTemplateContent(authenticityTemplate);

      if (reviewsFilter && authenticityContent) {
        authenticityContent.dataset.stampedInjected = 'authenticity';
        reviewsFilter.parentNode.insertBefore(authenticityContent, reviewsFilter);
        didInject = true;
      }
    }

    return didInject;
  }

  function watchWidget(widget) {
    injectIntoWidget(widget);

    var observer = new MutationObserver(function() {
      injectIntoWidget(widget);
    });

    observer.observe(widget, { childList: true, subtree: true });

    setTimeout(function() {
      observer.disconnect();
    }, 60000);
  }

  function init() {
    var widget = document.getElementById('stamped-main-widget');

    if (widget) {
      watchWidget(widget);
      return;
    }

    var docObserver = new MutationObserver(function() {
      widget = document.getElementById('stamped-main-widget');
      if (!widget) return;

      docObserver.disconnect();
      watchWidget(widget);
    });

    docObserver.observe(document.documentElement, { childList: true, subtree: true });

    setTimeout(function() {
      docObserver.disconnect();
    }, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

//FF UpCart EAA FIX: commented out for now as UpCart can do it themselves better directly in the code of the app.
/*

// UpCart accessibility fix: wrap cart drawer in proper landmark
(function fixUpCartAccessibility() {
  function addLandmarkToUpCart() {
    // Find the UpCart container (it's typically a div with upcart classes)
    var upCartRoot = document.querySelector('[class*="upcart"], [id*="upcart"], [class*="UpCart"]');
    if (upCartRoot && !upCartRoot.hasAttribute('role')) {
      upCartRoot.setAttribute('role', 'dialog');
      upCartRoot.setAttribute('aria-modal', 'true');
      upCartRoot.setAttribute('aria-label', 'Shopping cart');
    }

    // Fix the header text element - remove incorrect ARIA roles from heading
    var headerText = document.querySelector('.upcart-header-text');
    if (headerText) {
      // Remove dialog role from heading - it should only be on the container
      if (headerText.getAttribute('role') === 'dialog') {
        headerText.removeAttribute('role');
      }
      // Remove aria-modal from heading - it should only be on the container
      if (headerText.hasAttribute('aria-modal')) {
        headerText.removeAttribute('aria-modal');
      }
      // Remove tabindex as headings don't need manual focus
      if (headerText.hasAttribute('tabindex')) {
        headerText.removeAttribute('tabindex');
      }

      // Ensure the parent container has the correct dialog role
      var parent = headerText.closest('[role="dialog"]');
      if (!parent) {
        var wrapper = headerText.closest('[class*="upcart"]');
        if (wrapper && !wrapper.hasAttribute('role')) {
          wrapper.setAttribute('role', 'dialog');
          wrapper.setAttribute('aria-modal', 'true');
          wrapper.setAttribute('aria-label', 'Shopping cart');
        }
      }
    }

    // Fix the empty cart message
    var emptyCartHeading = document.querySelector('[class*="CartPreview__empty"] h3');
    if (emptyCartHeading) {
      var cartContainer = emptyCartHeading.closest('[class*="upcart"], [class*="UpCart"]');
      if (cartContainer && !cartContainer.hasAttribute('role')) {
        cartContainer.setAttribute('role', 'dialog');
        cartContainer.setAttribute('aria-modal', 'true');
        cartContainer.setAttribute('aria-label', 'Shopping cart');
      }
    }
  }

  // Run on DOM ready and observe for dynamically added elements
  function init() {
    addLandmarkToUpCart();

    // Observe for UpCart being added dynamically
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          addLandmarkToUpCart();
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }
})();

*/